import { render, staticRenderFns } from "./configuration-local-assays-assaygroups-laboratory-grid.vue?vue&type=template&id=2d1a7c2f&scoped=true&"
import script from "./configuration-local-assays-assaygroups-laboratory-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-assaygroups-laboratory-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-assaygroups-laboratory-grid.scss?vue&type=style&index=0&id=2d1a7c2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a7c2f",
  null
  
)

export default component.exports